// extracted by mini-css-extract-plugin
export default {"ReportCard":"reports_ReportCard__l+hdg","Icon":"reports_Icon__rtCIV","TableLink":"reports_TableLink__tTXSX"};